<template>
  <Dialog :visible="visible" class="irinox-dialog-light after-sales advanced-features" :modal="true" 
              :closable="false" :dismissableMask="true" :style="{width: '95vw', maxWidth: '600px'}" :draggable="false"
              @update:visible="updateVisible" @show="show">
    
    <template #header>
      <img src="assets/irinox/icons/arrow_back.svg" @click="updateVisible(false)" :alt="$t('common.arrow_left')"/>
      <div>{{$t('factory.advFeatures.title')}}</div>
    </template>

    <div class="irinox-dialog-light-content layout-content">

      <div class="visibility-company">{{ user.companyName }}</div>

      <div class="visibility-email p-mb-3">{{ user.email }}</div>

      <div v-if="user.role=='USER'" class="visibility-email p-mb-3"><i>{{ chatbotTooltip }}</i></div>

      <div class="irinox-form" >

        <!-- {{ user }} -->

        <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-6">
                  <label>{{ $t('factory.advFeatures.chatbot') }}</label>
                  <div class="p-field-checkbox p-my-1">
                      <RadioButton v-model="form.chatbot" class="p-mr-2" inputId="chatbot1" name="chatbot" :value="true" :disabled="userRole!='SUPERFACTORY'"/>
                      <p v-html="$t('factory.advFeatures.chatbot_true')"></p>
                  </div>
                  <div class="p-field-checkbox p-my-1">
                      <RadioButton v-model="form.chatbot" class="p-mr-2" inputId="chatbot2" name="chatbot" :value="false" :disabled="userRole!='SUPERFACTORY'" />
                      <p v-html="$t('factory.advFeatures.chatbot_false')"></p>
                  </div>  
              </div>
              <div class="p-field p-col-6" v-if="user.role.includes('SERVICE')">
                  <label>{{ $t('factory.advFeatures.seller') }}</label>
                  <div class="p-field-checkbox p-my-1">
                      <RadioButton v-model="form.seller" class="p-mr-2" inputId="seller1" name="seller" :value="true" />
                      <p v-html="$t('factory.advFeatures.seller_true')"></p>
                  </div>
                  <div class="p-field-checkbox p-my-1">
                      <RadioButton v-model="form.seller" class="p-mr-2" inputId="seller2" name="seller" :value="false" />
                      <p v-html="$t('factory.advFeatures.seller_false')"></p>
                  </div>  
              </div>
          </div>
      </div>




    </div>


    <template #footer>
      <!-- <Button :label="$t('factory.advFeatures.button')" @click="saveAdvFeatures(!v$.form.$invalid)"/> -->
      <Button :label="$t('factory.advFeatures.button')" @click="saveAdvFeatures()" :disabled="!(userRole=='SUPERFACTORY' || user.role.includes('SERVICE'))" />
    </template>
  </Dialog>

  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('factory.advFeatures.dialog_error')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.success" 
    mode="success" 
    :message="$t('factory.advFeatures.dialog_success')"
    :life="3000" 
    @update:visible="dialog.success = $event" />

</template>

<script>
// import { required, requiredIf } from "@vuelidate/validators";
// import { useVuelidate } from "@vuelidate/core";
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import AccountService from '../../service/AccountService';
import { mapGetters } from 'vuex';
export default {
    components: {
      IrinoxDialogDark
    },
    // setup: () => ({ v$: useVuelidate() }),
    emits: ['update:visible'],
    props: {
      visible: Boolean,
      user: Object,
    },
    data() {
        return {
          form: {
            seller: false,
            chatbot: false,
          },
          dialog: {
            error: false,
            success: false,
          },
          submitted: false,
        };
    },
    computed: {
      ...mapGetters({
        personaltoken: 'userdata/personaltoken',
        userRole: 'userdata/role',
      }),
      chatbotTooltip() {
        if(this.user.plans?.length > 0) {
          return this.$t('factory.advFeatures.chatbot_tooltip_purchased') + ': ' + this.user.plans.map(plan => this.$t('plans.codes.'+plan.code)).join(', ');
        } else {
          return this.$t('factory.advFeatures.chatbot_tooltip_empty');
        }
      }
    },
    validations() {
      return {
          // form: {
          //   type: {
          //       required
          //   },
          //   price: {
          //       required
          //   },
          //   docTreeKeys: {
          //       required: requiredIf(function() {
          //         return this.form.type==='PARTIAL'
          //       }),
          //   }
          // }
      }
    },
    watch: {
    },
    created() {
      this.accountService = new AccountService();
    },
    mounted() {
    },
    methods: {
      updateVisible(value) {
        if(!value) {
          this.form = {
            seller: false,
            chatbot: false,
          };
        }
        this.$emit("update:visible", value);
      },
      show() {
        this.form.seller = this.user.seller ?? false;
        this.form.chatbot = this.user.chatbot ?? false;
      },
      saveAdvFeatures() {
        this.accountService.saveAdvFeatures(this.personaltoken, this.user.email, this.form.chatbot, this.user.role.includes('SERVICE') ? this.form.seller : null)
            .then((data) => {
              if(data.code=="200") {
                this.dialog.success = true;
                this.updateVisible(false);
              } else {
                console.error(JSON.stringify(data));
                this.dialog.error = true;
              }
              })
            .catch(error => {
              console.error("ERROR "+error);
              this.dialog.error = true;
            });
      },
    }
}
</script>

<style>

</style>